import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import qs from 'qs';
import { useFetchSampleOrders } from '../../hooks/useSampleOrder';
import { useSampleOrderColumns } from '../../hooks/useColumns';
import MaterialTable from '../MaterialTable';
import PageLayout from '../atoms/PageLayout';
import { Box } from '@mui/material';
import i18n from '../../i18n';
import { convertLanguage } from '../../utils/languageUtils';
var RoasterSampleOrdersPage = function () {
    var location = useLocation();
    var t = useTranslation().t;
    var fetchSampleOrders = useFetchSampleOrders().fetchSampleOrders;
    var query = qs.parse(location.search.slice(1));
    var SampleOrderColumns = useSampleOrderColumns({
        role: 'roaster',
        filters: query.filters,
        orderBy: query.orderBy,
        orderDirection: query.orderDirection,
    });
    var columns = React.useMemo(function () { return [
        SampleOrderColumns.offerListLink,
        SampleOrderColumns.producerName,
        SampleOrderColumns.status,
        SampleOrderColumns.createdAt,
    ]; }, [SampleOrderColumns]);
    var convertedLanguage = convertLanguage(i18n.language);
    return (React.createElement(PageLayout, { title: React.createElement(React.Fragment, null,
            React.createElement(Box, { component: "p", sx: {
                    color: 'red',
                    fontSize: '0.9rem',
                    lineHeight: '1.5',
                    fontWeight: 'normal',
                } },
                React.createElement(Trans, { i18nKey: "messages.newPlatformSampleNotice" },
                    React.createElement("a", { href: "https://typica.coffee/".concat(convertedLanguage, "/my/sample-requests"), target: "_blank", rel: "noopener noreferrer", style: { color: 'red' } }))),
            React.createElement(Box, { component: "h4", sx: { typography: function (theme) { return theme.customTypography.h4; } } }, t('pages.sampleOrdersPage.title'))) },
        React.createElement(MaterialTable, { model: "sampleOrder", columns: columns, data: fetchSampleOrders, options: {
                initialPage: parseInt(query.page) || 0,
                pageSize: parseInt(query.pageSize) || 25,
                paging: true,
            }, detailPath: function (sampleOrder) { return "/roaster/sample_orders/".concat(sampleOrder.id); } })));
};
export default RoasterSampleOrdersPage;
